import React, { Component } from 'react';
import { unescapeSpecialChars } from 'src/main/js/helpers/helper_functions';
import { withTranslation } from 'react-i18next';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import { titleize } from 'underscore.string';
import CargomaticInput from 'components/v2/input';

const AddressForm = ({
  address,
  getHandleInputChange,
  getValidationState,
  t,
}) => {
  return (
    <div>
      <div className="grid grid-cols-6 gap-4 mt-3">
        <AuthorizationWrapper excludedRegions={[REGIONS.AP]}>
          <div
            controlId="street"
            className="col-span-6 sm:col-span-6"
            validationState={getValidationState('street')}
          >
            <CargomaticInput
              label={titleize(t('STREET'))}
              type="text"
              value={unescapeSpecialChars(address.street)}
              placeholder={t('ENTER_STREET')}
              onChange={getHandleInputChange('street')}
            />
          </div>
          <div
            controlId="city"
            className="col-span-6 sm:col-span-2"
            validationState={getValidationState('city')}
          >
            <CargomaticInput
              label={titleize(t('CITY'))}
              type="text"
              value={unescapeSpecialChars(address.city)}
              placeholder={t('ENTER_CITY')}
              onChange={getHandleInputChange('city')}
            />
          </div>
          <div
            controlId="state"
            className="col-span-6 sm:col-span-2"
            validationState={getValidationState('state')}
          >
            <CargomaticInput
              label={titleize(t('STATE'))}
              type="text"
              value={unescapeSpecialChars(address.state)}
              placeholder={t('ENTER_STATE')}
              onChange={getHandleInputChange('state')}
            />
          </div>
          <div
            className="col-span-6 sm:col-span-2"
            controlId="zipcode"
            validationState={getValidationState('zipcode')}
          >
            <CargomaticInput
              label={titleize(t('ZIP_CODE'))}
              value={address.zipcode}
              placeholder={t('ENTER_ZIP_CODE')}
              onChange={getHandleInputChange('zipcode')}
            />
          </div>
        </AuthorizationWrapper>
        <AuthorizationWrapper excludedRegions={[REGIONS.US]}>
          <div
            controlId="international_address"
            className="col-span-6 sm:col-span-6"
            validationState={getValidationState('international_address')}
          >
            <CargomaticInput
              label={titleize(t('ADDRESS'))}
              type="text"
              value={unescapeSpecialChars(address.international_address)}
              placeholder={t('ENTER_ADDRESS')}
              onChange={getHandleInputChange('international_address')}
            />
          </div>
          <div
            controlId="province"
            className="col-span-6 sm:col-span-2"
            validationState={getValidationState('province')}
          >
            <CargomaticInput
              label={titleize(t('PROVINCE'))}
              type="text"
              value={unescapeSpecialChars(address.province)}
              placeholder={t('ENTER_PROVINCE')}
              onChange={getHandleInputChange('province')}
            />
          </div>
          <div
            controlId="district"
            className="col-span-6 sm:col-span-2"
            validationState={getValidationState('district')}
          >
            <CargomaticInput
              label={titleize(t('DISTRICT'))}
              type="text"
              value={unescapeSpecialChars(address.district)}
              placeholder={t('ENTER_DISTRICT')}
              onChange={getHandleInputChange('district')}
            />
          </div>
          <div
            controlId="sub_district"
            className="col-span-6 sm:col-span-2"
            validationState={getValidationState('sub_district')}
          >
            <CargomaticInput
              label={titleize(t('SUB_DISTRICT'))}
              type="text"
              value={unescapeSpecialChars(address.sub_district)}
              placeholder={t('ENTER_SUB_DISTRICT')}
              onChange={getHandleInputChange('sub_district')}
            />
          </div>
          <div
            className="col-span-6 sm:col-span-2"
            controlId="post_code"
            validationState={getValidationState('post_code')}
          >
            <CargomaticInput
              label={titleize(t('POST_CODE'))}
              type="text"
              value={address.post_code}
              placeholder={t('ENTER_ZIP_CODE')}
              onChange={getHandleInputChange('post_code')}
            />
          </div>
          <div
            className="col-span-6 sm:col-span-1"
            controlId="country"
            validationState={getValidationState('country')}
          >
            <CargomaticInput
              label={titleize(t('COUNTRY'))}
              type="text"
              value={address.country}
              placeholder={t('ENTER_COUNTRY')}
              onChange={getHandleInputChange('country')}
            />
          </div>
        </AuthorizationWrapper>
      </div>
    </div>
  );
};

export default withTranslation()(AddressForm);
